<script setup>
defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  flush: { type: Boolean, default: false },
});
</script>

<template>
  <section
    class="overflow-hidden rounded-2xl border border-n-weak bg-teletel-panel shadow-[var(--teletel-shadow-card)]"
  >
    <header
      v-if="title || description || $slots.actions"
      class="flex flex-col gap-3 border-b border-n-weak px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div>
        <h2 v-if="title" class="text-base font-semibold text-n-slate-12">
          {{ title }}
        </h2>
        <p v-if="description" class="mt-1 text-sm text-n-slate-11">
          {{ description }}
        </p>
      </div>
      <div v-if="$slots.actions" class="flex flex-wrap gap-2">
        <slot name="actions" />
      </div>
    </header>
    <div :class="flush ? '' : 'p-5'"><slot /></div>
  </section>
</template>
